import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { Aviso } from '../aviso/aviso';
import { Alarma } from '../alarmas/alarma';

import myGlobals = require('../config');
import * as _ from "lodash";

@Injectable()
export class AvisoService {

  private avisoUrl = myGlobals.default.BASE_URL + '/aviso/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los avisos habilitados para el usuario
  getAvisos() {
    return this.http.get(this.avisoUrl)
      .map((response) => response.json());
  }

  //Obtener un aviso
  getAviso(_id: string): Observable<Aviso> {
    return this.http.get(this.avisoUrl + _id)
      .map((response) => response.json());
  }


  save(aviso: Aviso, alarma: Alarma): Observable<Aviso> {

    var avisoModificado = _.cloneDeep(aviso);
    if (avisoModificado.horaDesde != undefined)
      avisoModificado.horaDesde = avisoModificado.horaDesde.replace(":", "");
    if (avisoModificado.horaHasta != undefined)
      avisoModificado.horaHasta = avisoModificado.horaHasta.replace(":", "");

    if (avisoModificado._id) {
      return this.put(avisoModificado);
    }
    //Seteo estado activo
    avisoModificado.estado = true;
    return this.post(avisoModificado,alarma);
  }

  //Desactivar aviso
  delete(aviso: Aviso) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.avisoUrl}/${aviso._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  // Agregar nueva aviso
  private post(aviso: Aviso, alarma: Alarma): Observable<Aviso> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    var avisoStr = JSON.stringify(aviso);
    let url = `${this.avisoUrl}/${alarma._id}`;
    return this.http
      .post(url, avisoStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar aviso
  private put(aviso: Aviso) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.avisoUrl}/${aviso._id}`;

    return this.http
      .put(url, JSON.stringify(aviso), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/aviso/aviso.service.ts